import type { TSimulacaoSacocVOutput } from '@/features/simulador/brasil/types/simulacao.type'
import type { TGetSimulacaoDuplicarResponse } from '@/features/simulador/shared/__mocks__/simulacao.factory.mock'
import { HttpService } from '@/infra/http'
import type { TTipoProdutoPrecificadoBrasilEnum } from '@/types/produto'
import type { TEmpreendimentoSimulacao } from '@/types/simulacao'

export type TSimuladorLocationState = {
  empreendimento: TEmpreendimentoSimulacao
  idExternoProduto: number
  idExternoBloco: number
  tipoDoProduto: TTipoProdutoPrecificadoBrasilEnum
  simulacao?: TSimulacaoSacocVOutput['simulacao']
  simulacaoDuplicada?: TGetSimulacaoDuplicarResponse
}

export class GetSimulacaoDuplicarService extends HttpService {
  execute = async (simulacaoId: string) => {
    return this.http.get<TGetSimulacaoDuplicarResponse>(`/api/v2/Simulacao/${simulacaoId}/duplicar`)
  }
}
